export default "__VITE_ASSET__CqGN$uK5__"